import React, { FC } from 'react';
import { CancelButton, CloseIcon, ConfirmButton, FooterElem } from './Footer.styles';

interface IFooter {
  className?: string;
  cancelLabel: string;
  confirmLabel?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  hasBorder?: boolean;
}

const Footer: FC<IFooter> = ({
  className,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  hasBorder = false,
}) => (
  <FooterElem id="FooterElem" {...{ className, hasBorder }}>
    <CancelButton id="CancelButton" onClick={onCancel}>
      <CloseIcon />
      {cancelLabel}
    </CancelButton>
    {confirmLabel && onConfirm ? (
      <ConfirmButton id="ConfirmButton" onClick={onConfirm}>
        {confirmLabel}
      </ConfirmButton>
    ) : null}
  </FooterElem>
);

export default Footer;
